
const jsonLdUtil = {
    formatDate: function (date) {
      const reviewDay = new Date(date);
      const year = reviewDay.getFullYear();
      const month = ("0" + (reviewDay.getMonth() + 1)).slice(-2);
      const day = ("0" + reviewDay.getDate()).slice(-2);
      return `${year}-${month}-${day}`;
    },
    formatJsonLdForReviews: function (reviewsData) {
      let resultArray = [];
      for (const r of reviewsData) {
        resultArray.push({
          "@type": "Review",
          "reviewRating": {
            "@type": "Rating",
            "ratingValue": r.reviewRating
          },
          "author": {
            "@type": "Person",
            "name": r.author
          },
          "datePublished": jsonLdUtil.formatDate(r.dateCreated),
          "reviewBody": r.reviewMessage,
          "name": r.reviewTitle
        });
      }
      return resultArray;
    }
  };